<template>
  <div class="certificates">
    <transition appear @before-enter="beforeEnterBox" @enter="enterBox">
      <h2 data-index="1">Certificates</h2></transition
    >
    <transition appear @before-enter="beforeEnter" @enter="enter">
      <div class="container">
        <div class="slides">
          <div
            class="mySlides"
            v-for="certificate in certificates"
            :key="certificate.id"
          >
            <img :src="certificate.src" />
          </div>
          <a class="prev" @click="plusSlides(-1)"
            ><i class="icon chevron left"></i
          ></a>
          <a class="next" @click="plusSlides(1)">
            <i class="icon chevron right"></i>
          </a>
          <div class="caption-container">
            <p><a id="caption" href="" target="_blank"></a></p>
          </div>
        </div>
        <div class="row flex">
          <div
            class="column"
            v-for="certificate in certificates"
            :key="certificate.id"
          >
            <img
              class="demo cursor"
              :src="certificate.src"
              @click="currentSlide(certificate.id)"
              :alt="certificate.alt"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import slideShow from "../../composables/slideShow";
export default {
  props: {
    certificates: Array,
    beforeEnterBox: Function,
    enterBox: Function,
    beforeEnter: Function,
    enter: Function,
  },
  setup() {
    const slideIndex = ref(1);
    const { plusSlides, currentSlide, showSlides } = slideShow(slideIndex);
    onMounted(() => {
      showSlides(slideIndex);
    });
    return {
      slideIndex,
      plusSlides,
      currentSlide,
      showSlides,
    };
  },
};
</script>

<style scoped>
#resume .section > .certificates > h2 {
  background: var(--grey);
  color: var(--light);
}
#resume .section > .certificates:hover > h2 {
  padding-left: 3rem;
  padding-right: 3rem;
  background: var(--primary);
  color: var(--dark);
}
#resume .section > .certificates:hover > .container {
  padding: 1rem;
}
img {
  vertical-align: middle;
}
/* Position the image container (needed to position the left and right arrows) */
.container {
  position: relative;
  border: 1px solid var(--dark);
  padding: 1rem 3rem;
  margin: 1rem 0;
  border-radius: 5px;
}

/* Hide the images by default */
.mySlides {
  display: none;
}
.mySlides img {
  height: 400px;
}

/* Add a pointer when hovering over the thumbnail images */
.cursor {
  cursor: pointer;
}

/* Next & previous buttons */
.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 55%;
  width: auto;
  padding: 16px;
  margin-top: -50px;
  color: var(--secondary);
  font-weight: bold;
  font-size: 20px;
  border-radius: 0 5px 5px 0;
  user-select: none;
  -webkit-user-select: none;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 5px 0 0 5px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover,
.next:hover {
  background-color: #000000cc;
}

/* Container for image text */
.slides {
  position: relative;
}
.caption-container {
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  color: var(--light);
  background-color: var(--transparent);
}
#caption {
  margin: 0 auto;
  text-align: center;
  display: block;
  color: var(--secondary);
  padding: 0.5rem 1.3rem;
}
#caption:hover {
  color: var(--blue);
}
.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Six columns side by side */
.column {
  float: left;
  max-width: 130px;
}
.column img {
  height: 100px;
}
/* Add a transparency effect for thumnbail images */
.demo {
  opacity: 0.6;
}

.active,
.demo:hover {
  opacity: 1;
}

@media screen and (max-width: 520px) {
  .container {
    padding: 0;
    border: none;
  }
  #resume .section > .certificates:hover > .container {
    padding: 0;
  }
  #caption {
    font-size: 0.9rem;
    text-align: center;
    padding: 0.5rem;
  }
  .row {
    display: none;
  }
  #resume .section > .certificates:hover > h2 {
    padding: 7px 25px;
  }
  #resume p {
    margin: 0;
  }
}
</style>
